import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    expertRegistration: {},
    userInfo: {},
    search: ''
  },
  getters: {},
  mutations: {
    CLEAR_DATA(state) {
        state.expertRegistration = {}
    },

    SET_EXPERTrEGISTRATION(state, data) {
      state.expertRegistration = data
    },
    SET_USERINFO(state, data) {
      state.userInfo = data
    },
    CLEAR_USERINFO(state, data) {
      state.userInfo = data
    },
    SET_SEARCH(state, data) {
      state.search = data
    }
  },
  actions: {
    clearData({ commit }) {
      commit('CLEAR_DATA')
    },
  },
  modules: {},
  plugins: [createPersistedState()]
})
